var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchandFilterInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11921_20851)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7553 8.37771C21.7553 10.565 20.9171 12.5566 19.5443 14.0486L22.892 17.3963C23.3594 17.8637 23.3594 18.6215 22.892 19.0889C22.4246 19.5563 21.6668 19.5563 21.1995 19.0889L17.8143 15.7038C17.7692 15.6586 17.7284 15.6107 17.6919 15.5606C16.4317 16.3191 14.9556 16.7554 13.3776 16.7554C12.1758 16.7554 11.0331 16.5024 9.99992 16.0466V22.3698C9.99992 23.2893 8.8634 23.7214 8.25251 23.0342L6.25251 20.7842C6.0898 20.6011 5.99992 20.3647 5.99992 20.1198V14.9599C5.99992 14.668 5.87235 14.3907 5.65071 14.2007L1.05238 10.2593C0.347484 9.65506 0.774768 8.5 1.70317 8.5H5.00078C5.0002 8.45931 4.99991 8.41854 4.99991 8.37771C4.99991 3.75083 8.75074 0 13.3776 0C18.0045 0 21.7553 3.75083 21.7553 8.37771ZM20.5585 8.37771C20.5585 12.3436 17.3435 15.5586 13.3776 15.5586C9.41172 15.5586 6.19672 12.3436 6.19672 8.37771C6.19672 4.41181 9.41172 1.19682 13.3776 1.19682C17.3435 1.19682 20.5585 4.41181 20.5585 8.37771ZM12.4999 6.5H14.4999L14.4999 13.5H12.4999L12.4999 6.5ZM14.4999 3H12.4999V5H14.4999V3Z",
    fill: "#1B1B1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11921_20851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchandFilterInfo);
export default __webpack_public_path__ + "static/media/SearchandFilterInfo.6d1be354e06a1287b5076cd41d4756be.svg";
export { ForwardRef as ReactComponent };